var Control                      = require("enyo/Control"),
    CoverPlaceholder             = require("app/ui/covers/CoverPlaceholder"),
    GridArrangerOptions          = require("app/ui/repeaters/GridArrangerOptions"),
    Header                       = require("./Header"),
    CategoryCover                = require("app/ui/covers/CategoryCover"),
    NoContentView                = require("./NoContentView"),
    PrefixedVirtualizedRepeater  = require("app/ui/repeaters/PrefixedVirtualizedRepeater"),
    RepeaterArrayDiffDataAdapter = require("enyo-ui/RepeaterArrayDiffDataAdapter"),
    RepeaterPaddedGridArranger   = require("enyo-ui/RepeaterPaddedGridArranger"),
    ScrollAnchorMemorySupport    = require("app/ui/ScrollAnchorMemorySupport"),
    ScrollerDecoratorScrollbars  = require("app/ui/ScrollerDecoratorScrollbars"),
    ThumbnailPlaceholder         = require("app/ui/thumbnails/ThumbnailPlaceholder"),
    frameThrottle                = require("enyo-perf/utils").frameThrottle,
    get                          = require("object-path").get,
    kind                         = require("enyo/kind"),
    quickMacroize                = require("enyo/macroize").quickMacroize,
    resolveCoverKind             = require("app/utils/resolveCoverKind"),
    resolveThumbnailKind         = require("app/utils/resolveThumbnailKind"),
    themeVars                    = require("app/theme/variables"),
    utils                        = require("enyo/utils");

require("./CategoryGridPageView.less");
require("app/theme/ScrollerDecoratorScrollbars--page.less");

module.exports = kind(/** @lends  app.CategoryPage.CategoryGridPageView.prototype */ {

    /**
     * @private
     */
    name: "app.CategoryPage.CategoryGridPageView",

    /**
     * @private
     */
    kind: ScrollerDecoratorScrollbars,

    /**
     * @private
     */
    classes: "app-category-page-category-grid-page-view",

    /**
     * @private
     */
    fit: true,

    /**
     * @public
     */
    scrollerPath: ".$.grid.$.scroller",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * Default scroll-bars theme for desktop, minimal for mobile.
     *
     * @public
     */
    theme: "page",

    /**
     * If true, chrome will show when scrolling, hide when not scrolling.
     *
     * @type  {boolean}
     * @public
     */
    fadeChromeOnScroll: true,

    /**
     * @private
     */
    components: [{
        name:       "grid",
        kind:       PrefixedVirtualizedRepeater,
        mixins:     [ScrollAnchorMemorySupport],
        classes:    "app-category-page-category-grid-page-view__grid",
        components: [{
            name:    "header",
            kind:    Header,
            classes: "app-category-page-category-grid-page-view__header"
        }, {
            name:    "title",
            tag:     "h2",
            classes: "app-category-page-category-grid-page-view__title"
        }, {
            name:    "noContent",
            kind:    NoContentView,
            classes: "app-category-page-category-grid-page-view__no-content"
        }],
        dataAdapterKind: RepeaterArrayDiffDataAdapter,
        drawAsync:       true,
        scrollerOptions: {
            fit:            true,
            vertical:       true,
            horizontal:     false,
            scrollChaining: false
        },
        arrangerKind:    RepeaterPaddedGridArranger,
        arrangerOptions: utils.mixin(utils.clone(GridArrangerOptions), {

            /**
             * The amount of padding the bottom of the grid.
             *
             * @return {number}  The padding
             * @public
             */
            padBottom: function() {
                return themeVars.getContentPaddingVerticalPx() * 3;
            }
        }),

        /**
         * Determine which placeholder to show.
         *
         * @return  {enyo.Control}  The placeholder kind.
         * @public
         */
        getPlaceholderKind: function() {
            switch (this.get("childFormat")) {
                case "category_grid":
                case "category":
                case "cover":
                    return CoverPlaceholder;
                case "thumbnail":
                    return ThumbnailPlaceholder;
                default:
                    return null;
            }
        },

        /**
         * Optional extra options to merge into the placeholder kind at creation
         * time.
         *
         * @type {Object=}
         * @public
         */
        placeholderOptions: {
            bindings: [{
                from: ".repeater.showTitles",
                to:   ".showTitle",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?boolean}  showTitle Title visibility.
                 * @return  {boolean}   Whether to show the title.
                 * @private
                 */
                transform: function(showTitle) {
                    if (showTitle === undefined) {
                        return this.get("showTitle");
                    }
                    else {
                        return showTitle;
                    }
                }
            }, {
                from: ".repeater.childFormFactor",
                to:   ".formFactor",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?string}  formFactor Cover form-factor.
                 * @return  {string}   The desired form-factor.
                 * @private
                 */
                transform: function(formFactor) {
                    if (formFactor === undefined) {
                        return this.get("formFactor");
                    }
                    else {
                        return formFactor;
                    }
                }
            }]
        },

        /**
         * Determine which kind to use to display category items.
         *
         * @param   {Object}        media  The media item
         * @return  {enyo.Control}  The kind.
         * @private
         */
        getChildKind: function(media) {
            switch (this.get("childFormat")) {
                case "category_grid":
                case "category":
                    return CategoryCover;
                case "cover":
                    return resolveCoverKind(media);
                case "thumbnail":
                    return resolveThumbnailKind(media);
                default:
                    return Control;
            }
        },

        /**
         * Optional extra options to merge into the child kind at creation time.
         *
         * @type {Object}
         * @public
         */
        childOptions: {
            bindings: [{
                from: ".repeater.showTitles",
                to:   ".showTitle",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?boolean}  showTitle Title visibility.
                 * @return  {boolean}   Whether to show the title.
                 * @private
                 */
                transform: function(showTitle) {
                    if (showTitle === undefined) {
                        return this.get("showTitle");
                    }
                    else {
                        return showTitle;
                    }
                }
            }, {
                from: ".repeater.childFormFactor",
                to:   ".formFactor",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?string}  formFactor Cover form-factor.
                 * @return  {string}   The desired form-factor.
                 * @private
                 */
                transform: function(formFactor) {
                    if (formFactor === undefined) {
                        return this.get("formFactor");
                    }
                    else {
                        return formFactor;
                    }
                }
            }]
        }
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var state           = this.state || {},
            numItems        = get(state, "data.category_content.length", 0),
            $title          = this.$.title,
            $grid           = this.$.grid,
            childFormat     = get(state, "data.category_layout.format", "cover"),
            childFormFactor = get(state, "data.category_layout.formfactor", "portrait"),
            childSize       = "md",
            showTitles      = get(state, "data.category_layout.show_titles", true),
            anchorKey       = quickMacroize("CategoryPage/PageView/{$slug}", {
                slug: get(state, "data.meta.slug", null)
            }),
            needsReflow;

        this.$.header.set("data", get(state, "data", null));

        // If the slider isn't showing, the compact header will display the
        // title and we won't have to show it above the grid.
        if (!get(state, "data.slide_enabled", true)) {
            // We do still make use of the padding, so we don't hide the title.
            $title.set("content", "");
        }

        // If we are showing both slider and metadata, the title will be
        // displayed on top of the slider and we won't have to show it above the
        // grid.
        else if (get(state, "data.show_meta_text", false)) {
            // We do still make use of the padding, so we don't hide the title.
            $title.set("content", "");
        }

        // If we are showing the slider, but not the metadata, we do need to
        // display the title above the grid.
        else {
            $title.set("content", get(state, "data.meta.title", null) || "");
        }

        // The properties below can impact the arrangement of the repeater so
        // they need to be applied before we trigger a draw cycle by updating
        // the repeater's dataset.
        if (childFormFactor !== $grid.get("childFormFactor")) {
            $grid.set("childFormFactor", childFormFactor);
            needsReflow = true;
        }

        if (childSize !== $grid.get("childSize")) {
            $grid.set("childSize", childSize);
            needsReflow = true;
        }

        if (showTitles !== $grid.get("showTitles")) {
            $grid.set("showTitles", showTitles);
            needsReflow = true;
        }
        $grid.addRemoveClass("no-media", numItems === 0);
        $grid.$.client.set("fit", numItems === 0);

        // The childFormat determines which kinds are used to display the items
        // in the grid. In order to force the repeater to recreate all items
        // from scratch we need to delete the old ones first.
        if (childFormat !== $grid.get("childFormat")) {
            $grid.set("childFormat", childFormat);
            $grid.destroyPlaceholders();
            $grid.destroyChildren();

            // We also need to replace the layoutPlaceholder, because it's used
            // to determine the amount of columns shown in the grid.
            $grid.arranger.resetLayoutChild();
            needsReflow = true;
        }

        // Now that the grid's arrangement settings are all updated we can
        // reflow
        needsReflow && $grid.reflow();

        // This will trigger the repeater to re-draw. As such, any changes
        // resulting from either the dataset or the repeater options applied
        // above will be taken care of by the draw cycle.
        $grid.set("data", get(state, "data.category_content", []));
        $grid.set("anchorKey", anchorKey);

        anchorKey && $grid.restoreAnchor();
    }

});
